export default  {
  bindings: {
    period: '='
  },
  controller: 'periodsFormController',
  template: require('../views/periods.form.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/period/components/periods.form.component.js